import MessageModal from './MessageModal';

export default MessageModal;
export type { IModalMessage, IModalMessageButton } from './IModalMessage';
